/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * bundle.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";
import smoothscroll from "smoothscroll-polyfill";

/**
 * Passive Event Listener.
 */
document.addEventListener("touchstart", function () { }, {
  passive: true
});

/**
 * Run. 
 */
modules();
smoothscroll.polyfill();

/**
 * Clear console.
 */
console.clear();